FeedsApp.Models.Preview = FeedsApp.Models.FeedsBase.extend({
	url: function() {
		return "" + FeedsApp.Variables.PreviewId;
	}
});